<button mat-button class="{{ buttonName }} button-table" color="error" (click)="removeShipment()" [id]="buttonId">
    @if (!deletingCart) {
        <span>DELETE</span>
    }
    @if (deletingCart) {
        <mat-spinner color="error" diameter="20" />
    }
</button>
